module.exports = __webpack_public_path__ + "static/img/p1.f8a4091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p1.png
// module id = 0h12
// module chunks = 1